module.exports = __webpack_public_path__ + "static/circle_of_the_land_druid_mtg_clb-0fbf9034cff79ce84d761cabd35b390f.webp";